import { ErrorCode } from './ErrorCode'
import { AppError } from './AppError'
import { ErrorCategory } from './ErrorCategory'

export function mapToAppError(error: unknown): AppError {
  if (error instanceof AppError) {
    return error
  }
  if (error instanceof Error) {
    return new AppError({
      code: ErrorCode.UNEXPECTED,
      category: ErrorCategory.SYSTEM,
      retryable: false,
      details: {},
      message: error.message
    })
  }
  return new AppError({
    code: ErrorCode.UNEXPECTED,
    category: ErrorCategory.SYSTEM,
    retryable: false,
    details: {},
    message: 'An unexpected error occurred'
  })
}
